import { ThemeName } from "@/components/v3/theme";

/** Pages never use the "white" theme — it's only valid for standalone buttons/cards. */
export type PageTheme = Exclude<ThemeName, "white">;

/**
 * Single place declaring which theme each marketing page uses.
 * To change a page's theme, edit this list only — page.tsx files
 * read `theme` from here instead of hardcoding it per component.
 */
export const PAGE_THEMES: Record<string, PageTheme> = {
  // Counselling
  "/counselling": "purple",
  "/anger-management": "purple",
  "/relationships": "purple",
  "/depression-anxiety": "purple",
  "/grief-loss": "purple",
  "/career-counselling": "purple",

  // Life Coach
  "/life-coach": "yellow",
  "/self-esteem-confidence": "yellow",
  "/time-management": "yellow",
  "/focus-productivity": "yellow",
  "/changing-habits": "yellow",
  "/public-speaking": "yellow",

  // Allied Health
  "/allied-health": "red",
  "/occupational-therapy": "red",
  "/psychology": "red",
};

/** Fallback theme for any page not listed in PAGE_THEMES. */
export const DEFAULT_THEME: PageTheme = "blue";

export const getPageTheme = (pathname: string): PageTheme => {
  const match = Object.keys(PAGE_THEMES)
    .sort((a, b) => b.length - a.length)
    .find((p) => pathname === p || pathname.startsWith(p + "/"));
  return match ? PAGE_THEMES[match] : DEFAULT_THEME;
};
